import { render, staticRenderFns } from "./PortalCliente.vue?vue&type=template&id=54120dc8&scoped=true&"
import script from "./PortalCliente.vue?vue&type=script&lang=js&"
export * from "./PortalCliente.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PortalCliente.vue?vue&type=style&index=1&id=54120dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54120dc8",
  null
  
)

export default component.exports